export default __webpack_public_path__ + "static/media/logout.d8f45a98.svg";